import * as React from "react";
import { Alert, Form } from "react-bootstrap";
import { trpc } from "../trpc";
import styled from "styled-components";

interface Props {
  onLogin(token: string): void;
}

export function Login({ onLogin }: Props) {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState<string | null>(null);

  const { mutateAsync: login } = trpc.login.useMutation();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const response = await login({ email, password });
    if (response.success) {
      onLogin(response.token);
    } else {
      setError(response.error);
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Container>
        {error && (
          <Alert data-testid="login-error" variant="danger">
            {error}
          </Alert>
        )}
        <Form.Group className="mb-3">
          <Form.Control
            autoFocus
            placeholder="Email"
            type="email"
            value={email}
            style={{ padding: "10px .75rem" }}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Control
            placeholder="Password"
            type="password"
            value={password}
            style={{ padding: "10px .75rem" }}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>
        <Button type="submit" onClick={onSubmit}>
          Login
        </Button>
      </Container>
    </Form>
  );
}

const Button = styled.button`
  background: var(--theme-color-primary);
  border: none;
  padding: 10px 0;
  border-radius: 5px;
`;

const Container = styled.div`
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
`;
